import { z } from 'zod';

import {
  PartOfSpeechEnEnum,
  GenderEnum,
  PartOfSpeechRuEnum,
} from '../../enums';
import { languageEnumValidator } from '../../validators';

export const DetermineWordGrammarResponseSchema = z.object({
  type: z.union([
    z.nativeEnum(PartOfSpeechEnEnum),
    z.nativeEnum(PartOfSpeechRuEnum),
    z.string().min(1, 'Type cannot be empty'),
  ]),
  additionalInfo: z.record(languageEnumValidator, z.string()).optional(),
  gender: z.nativeEnum(GenderEnum).nullable(),
  plural: z.string().nullable(),
});

export type IDetermineWordGrammarResponseDto = z.infer<
  typeof DetermineWordGrammarResponseSchema
>;
